import React from "react";
import Dashboard from "../components/Dashboard";

const RegistrationDashboard = () => {
  return <Dashboard />;
};

export default RegistrationDashboard;
